import { IconButton as MUIIconButton, Button as MUIButton } from '@mui/material';
import { styled } from '@mui/system';

const Button = styled(MUIButton)({
  textTransform: 'none',
  borderRadius: 8
});
const IconButton = styled(MUIIconButton)();

export { Button, IconButton };
